
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { usePerformanceYear } from "@/contexts/PerformanceYearContext";

export const useUnitBandDisagreements = () => {
  const { activeYear } = usePerformanceYear();
  
  return useQuery({
    queryKey: ['unit-band-disagreements', activeYear],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        throw new Error("User not authenticated");
      }

      // Check if user is a unit head
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('is_unit_head')
        .eq('id', user.id)
        .single();

      if (userError || !userData?.is_unit_head) {
        return [];
      }

      // With the new RLS policies, we can simply query all band disagreements
      // The RLS policies will automatically filter to show only records that
      // the unit head has access to (same company members)
      // Also filter by active year
      const { data, error } = await supabase
        .from('band_disagreements')
        .select('*')
        .eq('year', activeYear)
        .order('submitted_date', { ascending: false });

      if (error) {
        console.error('Error fetching unit band disagreements:', error);
        throw error;
      }

      return data || [];
    },
  });
};
